<script>
    import { isMobile } from "@/utils";
    import TheSlider from "@main/packages/TheSlider";
    import TheMediaCard from "./components/TheMediaListCard";

    export default {
        name: "TheMediaList",
        components: {
            TheSlider,
            TheMediaCard,
        },
        props: {
            mediaList: Array,
            showDescriptions: {
                type: Boolean,
                default: false,
            },
            showLabels: {
                type: Boolean,
                default: true,
            },
            showResources: {
                type: Boolean,
                default: false,
            },
            previewHeight: [Number, String],
            titlePosition: String,
            breakpoints: Object,
            isScrollbar: {
                type: Boolean,
                default: false,
            },
            isBullets: {
                type: Boolean,
                default: true,
            },
            arrowPosition: {
                type: String,
                default: "bottom",
            },
        },
        data() {
            return {
                options: {
                    lazy: {
                        loadPrevNext: true,
                    },
                    watchSlidesVisibility: true,
                    slideVisibleClass: "visible",
                    ...this.breakpoints,
                },
                isMobileState: false,
            };
        },
        mounted() {
            this.isMobileState = this.isMobile(992);
            window.addEventListener("keyup", this.onEscapeKeyUp);
        },
        beforeDestroy() {
            window.removeEventListener("keyup", this.onEscapeKeyUp);
        },
        methods: {
            isMobile,
        },
    };
</script>

<template>
    <div class="the-media-list">
        <the-slider
            name-slider="media"
            :is-scrollbar="isScrollbar"
            :is-arrow="!isMobileState"
            :arrow-position="arrowPosition"
            :is-bullets="isBullets"
            :bullets-options="{ dynamicBullets: true }"
            :options="options"
            :list="mediaList"
        >
            <the-media-card
                class="swiper-slide"
                slot="swiper-slide"
                :media="media"
                :show-description="showDescriptions"
                :show-label="showLabels"
                :show-resource="showResources"
                :image-height="previewHeight"
                :title-position="titlePosition"
                v-for="media in mediaList"
                :key="media.id"
            ></the-media-card>
        </the-slider>
    </div>
</template>

<style lang="scss">
    .the-media-list {
        width: calc(100% + 32px);
        margin-left: -16px;

        &:hover {
            .c-slider__arrow {
                opacity: 1;
            }
        }

        @include bp($bp-mobile-sm) {
            width: 100%;
            margin: 0;
        }

        @include bp($bp-desktop-sm) {
            .media-card:not(.visible) {
                visibility: hidden;
                transition: visibility 0.5s ease-in;
            }
        }

        .c-slider__swiper {
            padding-left: 16px;

            @include bp($bp-mobile-sm) {
                padding-left: 0;
            }
        }

        .c-slider__scrollbar {
            width: calc(100% - 32px);
            margin-left: 16px;
            background-color: #3a4755;

            .swiper-scrollbar-drag {
                background-color: #fff;
            }

            @include bp($bp-mobile-sm) {
                width: 100%;
                margin-left: 0;
            }

            @include bp($bp-desktop-sm) {
                display: none;
            }
        }

        .c-slider__bottom-wrapper {
            @include bp($bp-desktop-md) {
                position: relative;
                width: 100vw;
                margin-left: 50vw;
                left: calc(1260px / 2 - 100vw);
            }
        }

        .c-slider__arrow {
            svg {
                fill: var(--slider-arrow-media);
            }
        }
    }
</style>
